import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getInspectionTypeList as getInspectionTypeListApi,
	getInspectionTypeListQuery as getInspectionTypeListQueryApi,
	getInspectionType as getInspectionTypeApi,
	addNewInspectionTypeApi,
	updateInspectionTypeApi,
	deleteInspectionTypeApi,
	checkInspectionTypeExistsApi,
} from '../../helpers/inspection_type/api_helper';

export const getInspectionTypeList = createAsyncThunk(
	'inspectionType/getInspectionTypeList',
	async () => {
		try {
			const response = await getInspectionTypeListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener tipos de fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getInspectionTypeListQuery = createAsyncThunk(
	'inspectionType/getInspectionTypeListQuery',
	async params => {
		try {
			const response = await getInspectionTypeListQueryApi(params);
			return response.data || response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getInspectionType = createAsyncThunk(
	'inspectionType/getInspectionType',
	async inspection_type_id => {
		try {
			const response = await getInspectionTypeApi(inspection_type_id);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener tipo de fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewInspectionType = createAsyncThunk(
	'inspectionType/addNewInspectionType',
	async inspection_type => {
		try {
			const response = await addNewInspectionTypeApi(inspection_type);
			toast.success('Tipo de Fiscalización agregado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar tipo de fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateInspectionType = createAsyncThunk(
	'inspectionType/updateInspectionType',
	async inspection_type => {
		try {
			const response = await updateInspectionTypeApi(inspection_type);
			toast.success('Tipo de Fiscalización actualizado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar tipo de fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteInspectionType = createAsyncThunk(
	'inspectionType/deleteInspectionType',
	async inspection_type => {
		try {
			await deleteInspectionTypeApi(inspection_type._id);
			toast.success('Tipo de Fiscalización eliminado exitosamente.', {
				autoClose: 3000,
			});
			return inspection_type;
		} catch (error) {
			toast.error('Error al eliminar tipo de fiscalización.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkInspectionTypeExists = createAsyncThunk(
	'inspectionType/checkInspectionTypeExists',
	async name => {
		try {
			const response = await checkInspectionTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
